import {BioentitySummary} from 'folder-items/FileConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export const BULK_TRANSLATION_SCREEN = 'BULK_TRANSLATION_SCREEN';

export interface TranslationSpec {
  tagSchemaField: SchemaField;
  firstCodonAnnotationName: string;
  firstCodonOffset: number | null;
}

export interface BulkTranslation {
  sequenceTagSchemaId: string | null;
  selectedIds: Array<string>;
  translationSpecs: Array<TranslationSpec>;
  outputFolderId: string | null;
  sequences: Array<BioentitySummary>;
  sequencesLoading: boolean;
  isRunning: boolean;
  errors: Array<string>;
}
